import React, {useEffect, useState} from "react";
import YearBtnOn from "../../../assets/images/classes/licenseYearBtnOn.png"
import YearBtnOff from "../../../assets/images/classes/licenseYearBtnOff.png"
import Button from "../../classStudentManagement/components/ButtonImg";
import ButtonImg from "../../classStudentManagement/components/ButtonImg";

const LicenseHistoryPage = ({licensesYear}) => {
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [data, setData] = useState(null);

    useEffect(() => {
        if(licensesYear) {
            setMaxPage(licensesYear.length);
        }
    }, [licensesYear]);

    useEffect( () => {
        if(licensesYear&&licensesYear.length>0){
            setData(licensesYear[page-1].licenseList);
        }
    }, [licensesYear, page])

    const tabYear = (diraction) => {
        if(diraction === "next"){
            if(page > 1){
                setPage(page - 1);
            }
        }else{
            if(page < maxPage){
                setPage(page + 1);
            }
        }
    };


    return (
        <>
            <div className="my-8 text-xl font-medium text-center text-zinc-600 max-md:max-w-full">
                내가 등록한 이용권 내역을 모두 확인할 수 있습니다.
            </div>
            {/* 연도 선택 버튼*/}
            <div className="flex justify-center items-center gap-16 ">

                {licensesYear&& licensesYear.length > 0 && page<maxPage ? (
                    <div className="transform scale-x-[-1]">
                        <ButtonImg
                            image={YearBtnOn}
                            onClick={() => tabYear("prev")}
                        />
                    </div>
                    )
                    : (
                        <div className="transform scale-x-[-1]">
                            <ButtonImg
                                image={YearBtnOff}
                                className="transform scale-x-[-1]"
                            />
                        </div>)}
                {licensesYear&& licensesYear.length > 0 ? (
                    <div
                        className="flex justify-center items-center w-[100px] text-[#50555F] text-[28px] font-[700]">{licensesYear[page - 1].year}
                    </div>
                ) : (
                    <div
                        className="flex justify-center items-center w-[100px] text-[#50555F] text-[28px] font-[700]">2025
                    </div>
                )

                }


                {licensesYear && licensesYear.length > 0 && page > 1 ? (
                        <div className="">
                        <ButtonImg
                                image={YearBtnOn}
                                onClick={() => tabYear("next")}
                            />
                        </div>
                    )
                    : (
                        <div className="">
                            <ButtonImg
                                image={YearBtnOff}
                                className="transform scale-x-[-1]"
                            />
                        </div>)}
            </div>
            <div className="relative w-full min-h-[200px] bg-white rounded-[20px] mt-[32px] mb-[150px] max-w-[1044px] px-[32px] py-[27px] shadow-custom">
                <table className="table-auto w-full overflow-hidden  rounded-t-[20px]">
                    <thead className="bg-[#F3F7FF] ">
                    <tr>
                        <th className="px-2 py-3 text-lg font-semibold text-[#9BA5C2] w-[70px]">
                            번호
                        </th>
                        <th className="px-2 py-3 text-lg font-semibold text-[#9BA5C2] w-[250px]">
                            이용권 상품명
                        </th>
                        <th className="px-2 py-3 text-lg font-semibold text-[#9BA5C2] w-[120px]">
                            기간
                        </th>
                        <th className="px-2 py-3- text-lg font-semibold text-[#9BA5C2] w-[338px]">
                            이용 기간
                        </th>
                        <th className="px-2 py-3- text-lg font-semibold text-[#9BA5C2] ">
                            등록 코드
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {data && data.length > 0 ? data.map((item, index) => (
                        <tr
                            key={index}
                            className={`${index > 0 ? 'border-t' : ''} bg-white  text-[#5e6169] text-sm font-medium ${index < data.length ? 'border-b' : ''}`}
                        >
                            <td className="px-3 h-[56px] text-sm font-medium items-center justify-center  border-r border-l">
                                {index+1}
                            </td>
                            <td className="px-3 h-[56px] text-sm font-medium items-center justify-center  border-r">
                                {item.voucherName}
                            </td>
                            <td className="px-3 h-[56px] text-sm font-medium items-center justify-center  border-r">
                                {item.duration}개월
                            </td>
                            <td className="px-3 h-[56px] text-sm font-medium items-center justify-center  border-r">
                                {item.licensePeriod}
                            </td>
                            <td className="px-3 h-[56px] text-sm font-medium items-center justify-center  border-r">
                                {item.voucherCode}
                            </td>
                        </tr>
                    )) : <tr>
                        <td colSpan="5" className="py-5">등록한 이용권이 없습니다.</td>
                    </tr>}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default LicenseHistoryPage;